<template>
    <div v-if="showCard" id="VisitorCalenderCard">
        <div id="CalendarCard">
            <div class="headtitle">
                <span class="text">Takvim</span>
            </div>
            <ul>
                <li v-for="(event, index) in (visitorEvents || []).slice(-5)" :key="index" @click="getDetail()">
                    {{ event.summary }} - {{ formatDate(event.start.dateTime) }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
    name: "VisitorCalenderCard",
    props: {
        visitorId: {
            type: String,
            default: "",
        },
    },
    components: {},
    data() {
        return {
            showCard: false,
            visitorEvents: null,
        };
    },
    methods: {
        ...mapActions({
            getVisitorEvents: "calendar/getVisitorEvents",
        }),
        async fetchVisitorEvents() {
            const events = await this.getVisitorEvents({ visitorId: this.visitorId });
            this.updateVisitorEvents(events);
        },
        updateVisitorEvents(events) {
            this.visitorEvents = events;
            if (this.visitorEvents.length === 0) {
                this.showCard = false;
            } else {
                this.showCard = true;
            }
        },
        formatDate(date) {
            return moment(date).format("L LT");
        },
        getDetail() {
            this.$router.push("calendar/d/");
        },
    },
    mounted() {
        this.fetchVisitorEvents();
    },
    watch: {
        visitorId(val) {
            this.fetchVisitorEvents();
        },
    },
};
</script>
<style lang="scss" scoped>
#VisitorCalenderCard {
    margin-bottom: 10px;

    #CalendarCard {
        z-index: 9;
        background-color: #ffffff;
        padding: 15px 15px;
        margin-bottom: 10px;
        border-radius: 6px;

        .details-chat-card {
            &:first-child {
                margin-top: 0px !important;
            }

            .user-detail {
                display: flex;
                align-items: center;
                margin-top: 5px;

                .input-value {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    overflow: hidden;

                    .disableShortcut {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                    }

                    .edited-input {
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        width: 80%;
                        margin-right: 5px;
                    }

                    .w-full {
                        text-overflow: ellipsis;
                        overflow: hidden;
                        width: 75%;
                        white-space: nowrap;
                    }
                }

                .icon {
                    margin-right: 8px;
                    color: #ffa800;
                    cursor: text;
                }
            }
        }

        .user-detail-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .headtitle {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
            font-size: 16px;
            font-weight: 600;
            font-family: Poppins;
        }
    }

    ul {
        list-style-type: none;

        li {
            position: relative;
            margin-bottom: 10px;
            font-weight: bold;
            cursor: pointer;

            &::before {
                content: "";
                position: absolute;
                left: -20px;
                top: 50%;
                transform: translateY(-50%);
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #ffa800;
            }
        }
    }
}
</style>
